import React from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Grid, Row, Col, Text } from 'shared/components'

import * as styles from './styles'

const ApproveButtonComponent = ({ value: event, onApproveMemberInvoice }) => (
  <Grid>
    <Row center="xs">
      <Col xs={12}>
        <Button
          circle
          small
          outlined
          disabled={event.currentState !== 'DRAFT'}
          onClick={onApproveMemberInvoice}
        >
          <FontAwesomeIcon size="lg" icon="fa-check" css={styles.icon} />
          <Text size={11}>Approve</Text>
        </Button>
      </Col>
    </Row>
  </Grid>
)

ApproveButtonComponent.propTypes = {
  value: PropTypes.shape(),
  onApproveMemberInvoice: PropTypes.func.isRequired,
}

export default ApproveButtonComponent
